import { h } from "preact";
import { observer } from "mobx-react";
import ItemCountBadge from "./ItemCountBadge";
import PreactTooltip from "../../components/PreactTooltip";
function SectionItemColumn({ column }) {
    return (h(PreactTooltip, { title: column.variantParameterChoiceName },
        column.price.priceValue,
        " ",
        h(ItemCountBadge, { count: column.inCartQuantity })));
}
export default observer(SectionItemColumn);
